"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextConsumer = exports.ContextProvider = void 0;

var React = __importStar(require("react"));

var constants_1 = require("./constants");

var get_rebilly_api_1 = __importDefault(require("./get-rebilly-api"));

var defaultContextValue = {
  api: get_rebilly_api_1.default(),
  error: null,
  ready: false
}; // tslint:disable:no-let

var ProvidedContext;

if (/^15.*/.test(constants_1.REACT_VERSION) || /^0.14.*/.test(constants_1.REACT_VERSION)) {
  // tslint:disable:no-var-requires
  var createReactContext = require('create-react-context');

  ProvidedContext = createReactContext(defaultContextValue);
} else {
  ProvidedContext = React.createContext(defaultContextValue);
}

var ContextProvider = ProvidedContext.Provider;
exports.ContextProvider = ContextProvider;
var ContextConsumer = ProvidedContext.Consumer;
exports.ContextConsumer = ContextConsumer;